/**
 * Moved to `shared/src/review/serp-structure-passage.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildCollapsedStructurePassageSegments,
  dedupeOverlappingStructurePassages,
  parseStructurePassageHeading
} from '@taptimize/shared/dist/review/serp-structure-passage';
export type {
  StructurePassageHeading
} from '@taptimize/shared/dist/review/serp-structure-passage';
